function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m6.5315 9.7915v13.458h6.0917v-18.438z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m6.5315 9.7915v13.458h6.0917v-18.438z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 7.6,
  strokeWidth: 0.8
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m34.449 9.8738v13.54h-6.0917v-18.603z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref5 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 7.6,
  strokeWidth: 0.8
}, React.createElement("path", {
  d: "m30.498 9.1155v2.4466"
}), React.createElement("path", {
  d: "m30.498 14.207v2.6399"
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m28.357 4.811 6.0917 5.0622c0.04116 0.49388 0 0.87713 0 1.4945",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m16.41 0.53134v1.8109h7.7381v-1.8109z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m16.551 0.53134h7.9143v1.8109h-7.9143z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 0.8
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m14.539 1.5312v1.3765h11.914v-1.3765z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m14.504 1.5312h12.09v2.2926h-12.09z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 0.8
});
var _ref0 = /*#__PURE__*/React.createElement("path", {
  className: "icon-secondary",
  d: "m22.055 15.224v2.6752h3.4241v-2.6752zm-6.51 0v2.6752h3.4241v-2.6752zm6.51-4.7741v2.6752h3.4241v-2.6752zm-6.51 0v2.6752h3.4241v-2.6752zm6.51-4.6507v2.6752h3.4241v-2.6752zm-6.51 0v2.6752h3.4241v-2.6752zm-3.0859-2.7986h16.064v20.414h-6.2141v-3.416h-3.6355v3.416h-6.2141z",
  fill: "#adb9ca",
  fillRule: "evenodd"
});
var _ref1 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m24.433 15.224h-2.3776v2.6752h2.3278m-8.8378-2.6752v2.6752h3.4241v-2.6752zm6.51-4.7741v2.6752h3.4241v-2.6752zm-6.51 0v2.6752h3.4241v-2.6752zm6.51-4.6507v2.6752h3.4241v-2.6752zm-6.51 0v2.6752h3.4241v-2.6752zm8.9978 17.605c-1.3472 0.0031-1.772 0.0095-2.2338 0.0099v-3.416h-3.6355v3.416h-6.2141l-3e-4 -20.414h16.064v8.5625",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 0.8
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m6.5729 18.64 0.12115 0.20578c1.2519 1.2758 2.9479 2.0578 4.8459 2.0578 1.9384 0 3.6344-0.78197 4.8863-2.0578l0.12115-0.20578 1.0096 0.24694c2.9479 1.2347 4.9671 4.1568 4.9671 7.6139v6.9143l-3.5537 1.317c-2.3826 0.57619-4.8863 0.86428-7.4304 0.86428-2.5037 0-5.0075-0.2881-7.39-0.86428l-3.5941-1.317v-6.9143c0-3.4571 2.0595-6.3792 5.0075-7.6139z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  transform: "matrix(1.0075 0 0 1.0268 -1.9479 -.044853)",
  d: "m8.4571 18.197 0.12024 0.2004c1.2425 1.2425 2.9259 2.004 4.8097 2.004 1.9239 0 3.6073-0.76154 4.8498-2.004l0.12024-0.2004 1.002 0.24048c2.9259 1.2024 4.93 4.0482 4.93 7.415v6.7336l-3.5271 1.2826c-2.3648 0.56113-4.8498 0.8417-7.3749 0.8417-2.485 0-4.97-0.28057-7.3348-0.8417l-3.5672-1.2826v-6.7336c0-3.3668 2.0441-6.2125 4.97-7.415z",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 8,
  strokeWidth: 0.78652
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m4.7557 14.442c0-3.8275 3.1095-6.9966 6.8651-6.9966 3.796 0 6.8651 3.169 6.8651 6.9966 0 3.8687-3.0691 6.9966-6.8651 6.9966-3.7556 0-6.8651-3.1279-6.8651-6.9966z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m4.7557 14.442c0-3.8275 3.1095-6.9966 6.8651-6.9966 3.796 0 6.8651 3.169 6.8651 6.9966 0 3.8687-3.0691 6.9966-6.8651 6.9966-3.7556 0-6.8651-3.1279-6.8651-6.9966",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 8,
  strokeWidth: 0.8
});
var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "icon-primary",
  d: "m27.653 15.998c0-1.1905 0.97935-2.1646 2.1763-2.1646h27.618c1.197 0 2.1546 0.97406 2.1546 2.1646v16.472c0 1.1905-0.95759 2.1429-2.1546 2.1429h-27.618c-1.197 0-2.1763-0.95241-2.1763-2.1429z",
  fill: "#ecaec6",
  fillRule: "evenodd"
});
var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m27.566 16c0-1.1902 0.98017-2.1641 2.1781-2.1641h27.641c1.198 0 2.1564 0.97383 2.1564 2.1641v16.469c0 1.1902-0.95838 2.1424-2.1564 2.1424h-27.641c-1.198 0-2.1781-0.95219-2.1781-2.1424z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.80241
});
var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "m33.469 23.531 0.06494 0.10823c0.60608 0.60608 1.4719 0.9957 2.4027 0.9957 0.95241 0 1.8182-0.38962 2.4243-0.9957l0.06494-0.10823 0.49785 0.10823c1.4503 0.62773 2.4676 2.0563 2.4676 3.7447v3.3984l-1.7533 0.62773c-1.1905 0.30304-2.446 0.43292-3.7014 0.43292-1.2338 0-2.4893-0.12987-3.6798-0.43292l-1.775-0.62773v-3.3984c0-1.6884 1.039-3.117 2.4893-3.7447z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m33.469 23.531 0.06494 0.10823c0.60608 0.60608 1.4719 0.9957 2.4027 0.9957 0.95241 0 1.8182-0.38962 2.4243-0.9957l0.06494-0.10823 0.49785 0.10823c1.4503 0.62773 2.4676 2.0563 2.4676 3.7447v3.3984l-1.7533 0.62773c-1.1905 0.30304-2.446 0.43292-3.7014 0.43292-1.2338 0-2.4893-0.12987-3.6798-0.43292l-1.775-0.62773v-3.3984c0-1.6884 1.039-3.117 2.4893-3.7447z",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 8,
  strokeWidth: 0.8
});
var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "m32.56 21.497c0-1.8832 1.5368-3.42 3.42-3.42 1.9048 0 3.42 1.5368 3.42 3.42 0 1.9048-1.5152 3.42-3.42 3.42-1.8832 0-3.42-1.5152-3.42-3.42z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m32.56 21.497c0-1.8832 1.5368-3.42 3.42-3.42 1.9048 0 3.42 1.5368 3.42 3.42 0 1.9048-1.5152 3.42-3.42 3.42-1.8832 0-3.42-1.5152-3.42-3.42",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 8,
  strokeWidth: 0.8
});
var _ref20 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(23.006 8.4918)",
  fill: "#fff",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "m22.195 10.883c0-0.17317 0.17317-0.34633 0.34633-0.34633h9.5241c0.19481 0 0.34633 0.17317 0.34633 0.34633v1.3853c0 0.19481-0.15152 0.34633-0.34633 0.34633h-9.5241c-0.17317 0-0.34633-0.15152-0.34633-0.34633z"
}), React.createElement("path", {
  d: "m22.195 15.819c0-0.17317 0.17317-0.34633 0.34633-0.34633h9.5241c0.19481 0 0.34633 0.17317 0.34633 0.34633v1.3853c0 0.19481-0.15152 0.34633-0.34633 0.34633h-9.5241c-0.17317 0-0.34633-0.15152-0.34633-0.34633z"
}), React.createElement("path", {
  d: "m22.195 20.754c0-0.17317 0.17317-0.34633 0.34633-0.34633h9.5241c0.19481 0 0.34633 0.17317 0.34633 0.34633v1.3853c0 0.19481-0.15152 0.34633-0.34633 0.34633h-9.5241c-0.17317 0-0.34633-0.15152-0.34633-0.34633z"
}));
var _ref21 = /*#__PURE__*/React.createElement("path", {
  className: "icon-secondary",
  d: "m37.841 12.578c0-0.30304 0.25975-0.56279 0.56279-0.56279h9.8055c0.30304 0 0.54114 0.25975 0.54114 0.56279v2.1862c0 0.30304-0.2381 0.54114-0.54114 0.54114h-9.8055c-0.30304 0-0.56279-0.2381-0.56279-0.54114z",
  fill: "#adb9ca",
  fillRule: "evenodd"
});
var _ref22 = /*#__PURE__*/React.createElement("g", {
  className: "icon-tertiary",
  transform: "translate(23.006 8.4918)",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 0.8
}, React.createElement("path", {
  d: "m22.195 10.883c0-0.17317 0.17317-0.34633 0.34633-0.34633h9.5241c0.19481 0 0.34633 0.17317 0.34633 0.34633v1.3853c0 0.19481-0.15152 0.34633-0.34633 0.34633h-9.5241c-0.17317 0-0.34633-0.15152-0.34633-0.34633z"
}), React.createElement("path", {
  d: "m22.195 15.819c0-0.17317 0.17317-0.34633 0.34633-0.34633h9.5241c0.19481 0 0.34633 0.17317 0.34633 0.34633v1.3853c0 0.19481-0.15152 0.34633-0.34633 0.34633h-9.5241c-0.17317 0-0.34633-0.15152-0.34633-0.34633z"
}), React.createElement("path", {
  d: "m22.195 20.754c0-0.17317 0.17317-0.34633 0.34633-0.34633h9.5241c0.19481 0 0.34633 0.17317 0.34633 0.34633v1.3853c0 0.19481-0.15152 0.34633-0.34633 0.34633h-9.5241c-0.17317 0-0.34633-0.15152-0.34633-0.34633z"
}), React.createElement("path", {
  d: "m14.835 4.0867c0-0.30304 0.25975-0.56279 0.56279-0.56279h9.8055c0.30304 0 0.54114 0.25975 0.54114 0.56279v2.1862c0 0.30304-0.2381 0.54114-0.54114 0.54114h-9.8055c-0.30304 0-0.56279-0.2381-0.56279-0.54114z"
}));
var SvgMenuSysadminProfile = function SvgMenuSysadminProfile(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 60,
    height: 36,
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref0, _ref1, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMenuSysadminProfile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Menu-Sysadmin-Profile.1c4a5b35.svg";
export { ForwardRef as ReactComponent };